module.exports = __webpack_public_path__ + "images/confidence-interval-03-desktop.png";